import { RoleCode } from 'hooks/useGetRoles';
import { ReactNode } from 'react';
import { useUserStoreActions } from 'store/UserStore';

export type RoleGuardProps = {
  roles: RoleCode[];
  children: ReactNode;
  fallback?: ReactNode;
};

export const RoleGuardComponent = ({
  roles,
  children,
  fallback = null,
}: RoleGuardProps) => {
  const { hasUserPermissionRole } = useUserStoreActions();

  const isUserAllowed = roles.some((role) => hasUserPermissionRole(role));

  if (!isUserAllowed) {
    return <>{fallback}</>;
  }

  // empty fragment required while passing Outlet as children
  return <>{children}</>;
};
